/*
 * Campaña Cyber: decide el estado (antes, durante, fin) con la hora de Chile y
 * mueve las cuentas regresivas. Se carga en el <head> sin defer para que el
 * estado quede puesto antes de pintar y no salte la barra de anuncios.
 */
(() => {
  const raiz = document.documentElement;
  const zona = 'America/Santiago';
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: zona, hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
  });

  // Diferencia entre la hora de Santiago y UTC en un instante (cambia con el horario de verano)
  const desfase = (ms) => {
    const p = Object.fromEntries(partes.formatToParts(new Date(ms)).map((x) => [x.type, x.value]));
    return Date.UTC(+p.year, p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - ms;
  };

  // "2026-10-05 00:00" en hora de Chile -> milisegundos UTC
  const aMs = (texto) => {
    const m = /(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(texto || '');
    if (!m) return NaN;
    const local = Date.UTC(+m[1], m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    const aprox = local - desfase(local);
    return local - desfase(aprox);
  };

  const inicio = aMs(raiz.dataset.cyberInicio);
  const fin = aMs(raiz.dataset.cyberFin);
  if (isNaN(fin)) { raiz.dataset.cyber = 'fin'; return; }

  const estado = (ahora) => (ahora >= fin ? 'fin' : !isNaN(inicio) && ahora < inicio ? 'antes' : 'durante');
  raiz.dataset.cyber = estado(Date.now());

  // Urgencia: el día antes del final, el último día (fecha de Chile) y las últimas 3 horas
  const fecha = (ms) => {
    const p = Object.fromEntries(partes.formatToParts(new Date(ms)).map((x) => [x.type, x.value]));
    return `${p.year}-${p.month}-${p.day}`;
  };
  const diaFin = fecha(fin);
  const urgencia = (ahora) => {
    if (estado(ahora) !== 'durante') return '';
    if (fin - ahora <= 3 * 3600000) return 'horas';
    if (fecha(ahora) === diaFin) return 'ultimo';
    if (fecha(ahora + 86400000) === diaFin) return 'manana';
    return '';
  };
  const pintarUrgencia = (ahora) => {
    const u = urgencia(ahora);
    if (u) raiz.dataset.cyberMomento = u; else delete raiz.dataset.cyberMomento;
    document.querySelectorAll('span[data-cyber-urgencia]').forEach((el) => {
      const texto = u ? el.dataset[u] || '' : '';
      if (el.textContent !== texto) el.textContent = texto;
      el.hidden = !texto;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => pintarUrgencia(Date.now()), { once: true });
  else pintarUrgencia(Date.now());

  const dos = (n) => String(n).padStart(2, '0');

  class CyberReloj extends HTMLElement {
    // El script corre en el <head>: al conectarse, las cifras todavía no existen
    connectedCallback() {
      CyberReloj.todos.add(this);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.pintar(Date.now()), { once: true });
      else this.pintar(Date.now());
    }

    buscar() {
      if (this.s) return;
      this.d = this.querySelector('[data-d]');
      this.h = this.querySelector('[data-h]');
      this.m = this.querySelector('[data-m]');
      this.s = this.querySelector('[data-s]');
      this.dia = this.querySelector('[data-dias]');
      this.texto = this.querySelector('[data-estado]');
    }

    disconnectedCallback() { CyberReloj.todos.delete(this); }

    pintar(ahora) {
      const e = estado(ahora);
      if (e === 'fin') return;
      this.buscar();
      const meta = e === 'antes' ? inicio : fin;
      let resto = Math.max(0, Math.floor((meta - ahora) / 1000));
      const d = Math.floor(resto / 86400); resto -= d * 86400;
      const h = Math.floor(resto / 3600); resto -= h * 3600;
      const m = Math.floor(resto / 60);
      const s = resto - m * 60;
      if (this.texto) this.texto.textContent = e === 'antes' ? this.dataset.antes : this.dataset.durante;
      if (this.d) this.d.textContent = d;
      if (this.dia) this.dia.hidden = d === 0;
      if (this.h) this.h.textContent = dos(h);
      if (this.m) this.m.textContent = dos(m);
      if (this.s) this.s.textContent = dos(s);
    }
  }
  CyberReloj.todos = new Set();
  if (!customElements.get('cyber-reloj')) customElements.define('cyber-reloj', CyberReloj);

  setInterval(() => {
    const ahora = Date.now();
    const e = estado(ahora);
    if (raiz.dataset.cyber !== e) raiz.dataset.cyber = e;
    CyberReloj.todos.forEach((r) => r.pintar(ahora));
    pintarUrgencia(ahora);
  }, 1000);
})();
